import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleUp, faSliders } from '@fortawesome/free-solid-svg-icons';
import AmenitiesSelection from './AmenitiesSelection';
import BudgetSelection from './BudgetSelection';
import HotelNameSelection from './HotelNameSelection';
import StarRatingSelection from './StarRatingSelection';
import BrandSelection from './BrandSelection';

export default function MoreSettings() {
  const [showMoreSettings, setShowMoreSettings] = useState(false);

  return (
    <div className="moreSettings">
      <div className="set">
        <Button variant="warning" onClick={() => setShowMoreSettings(!showMoreSettings)}>
          {showMoreSettings ? (
            <>
              <FontAwesomeIcon icon={faAngleUp} className="mx-2" />
              Close Filter
            </>
          ) : (
            <>
              <FontAwesomeIcon icon={faSliders} className="mx-2" />
              Filter
            </>
          )}
        </Button>
      </div>
      <div className="moreSettings_content" style={{ display: showMoreSettings ? 'block' : 'none' }}>
        <div className="input_search">
          <BudgetSelection />
          <BrandSelection />
          <HotelNameSelection />
        </div>
        <div className="table_search">
          <StarRatingSelection />
          <AmenitiesSelection />
        </div>
      </div>
    </div>
  );
}
